'use client'

import { useNavigation } from 'hooks/useNavigation/useNavigation'
import { StorePreviousUrl } from 'links/login/shared/StorePreviousUrl'
import { useEffect } from 'react'
import { useSession } from 'session/src/hooks/useSession'
import { shouldRedirectToLogin } from 'utils/shouldRedirectToLogin/shouldRedirectToLogin'
import { useGuestEmail } from 'utils/useGuestEmail/useGuestEmail'

export function RedirectToLogin({ isGuestAllowed = true }) {
	const { isReady, logged } = useSession()
	const guestEmail = useGuestEmail()

	const { navigate } = useNavigation()

	useEffect(() => {
		if (
			shouldRedirectToLogin({
				isReady,
				logged,
				guestEmail,
				isGuestAllowed,
			})
		) {
			navigate('/login')
		}
	}, [isReady, logged])

	return <StorePreviousUrl />
}
